import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";

export interface IVSNSavingPlan {
	globalOptIn: boolean;
	visionBonus: boolean;
	eligibleForVsn: boolean;
	feeDiscount: string;
	isAssetVSN: boolean;
}

const initialState: IVSNSavingPlan = {
	globalOptIn: false,
	visionBonus: false,
	eligibleForVsn: false,
	feeDiscount: "0",
	isAssetVSN: false
};
@Injectable({ providedIn: "root" })
export class VsnSavingPlanState extends StateService<IVSNSavingPlan> {
	public constructor() {
		super(initialState);
	}

	public getVsnSavingPlan$(): Observable<IVSNSavingPlan> {
		return this.select((state: IVSNSavingPlan) => state);
	}

	public setVsnSavingPlan(state: IVSNSavingPlan): void {
		this.setState(state);
	}

	public clearVsnSavingPlan(): void {
		this.setState(null);
	}
}
